// Импортируем стили
import '../css/app.scss';

// Импортируем Vue
import Vue from 'vue';

// Импортируем компоненты
import BookCard from './components/BookCard.vue';
import AddToLibraryModal from './components/AddToLibraryModal.vue';
import AddToLibraryButton from './components/AddToLibraryButton.vue';
import FavoriteToggle from './components/FavoriteToggle.vue';
import QuickShelfPicker from './components/QuickShelfPicker.vue';
import LibraryCollection from './components/LibraryCollection.vue';
import UserLibraryBookCard from './components/UserLibraryBookCard.vue';
import NotificationBell from './components/NotificationBell.vue';
import NotificationsPage from './components/NotificationsPage.vue';
import NotificationFilters from './components/NotificationFilters.vue';
import NotificationCard from './components/NotificationCard.vue';
import NotificationPagination from './components/NotificationPagination.vue';
import DiscussionReply from './components/DiscussionReply.vue';
import DiscussionRepliesList from './components/DiscussionRepliesList.vue';
import ReviewReply from './components/ReviewReply.vue';
import ReviewsRepliesList from './components/ReviewsRepliesList.vue';
import ReviewDetailBookContext from './components/reviews/ReviewDetailBookContext.vue';
import QuoteCard from './components/books/QuoteCard.vue';
import QuotesList from './components/books/QuotesList.vue';
import QuotesPageList from './components/books/QuotesPageList.vue';
import AddQuoteModal from './components/books/AddQuoteModal.vue';
import InterestingFacts from './components/books/InterestingFacts.vue';
import BookReviewsList from './components/books/ReviewsList.vue';
import FactCard from './components/books/FactCard.vue';
import FactsList from './components/books/FactsList.vue';
import FactsPageList from './components/books/FactsPageList.vue';
import PriceComparison from './components/books/PriceComparison.vue';
import HashtagContributionList from './components/HashtagContributionList.vue';
import UnifiedContentList from './components/UnifiedContentList.vue';
import ContentFilters from './components/ContentFilters.vue';
import ReportModal from './components/ReportModal.vue';
import ReportButton from './components/ReportButton.vue';
import FeaturedQuotesCarousel from './components/quotes/FeaturedQuotesCarousel.vue';
import LibrariesExplorer from './components/LibrariesExplorer.vue';
import LibraryBooksManager from './components/LibraryBooksManager.vue';
import BookSearch from './components/BookSearch.vue';
import DiscussionWorkSelector from './components/DiscussionWorkSelector.vue';
import Pagination from './components/Pagination.vue';
import ToastNotification from './components/ToastNotification.vue';
import DecisionModal from './components/DecisionModal.vue';
import OpinionTypeIcon from './components/OpinionTypeIcon.vue';
import DoubleRangeSlider from './components/DoubleRangeSlider.vue';
import RatingInput from './components/RatingInput.vue';
import UserAvatar from './components/UserAvatar.vue';
import ReadingContextSelector from './components/ReadingContextSelector.vue';
import { initPageSwipers } from './swiper-init';
import { initCategoryChildNav } from './category-child-nav';
import bookStatusCache from './utils/bookStatusCache';
import bookIdCache from './utils/bookIdCache';
import feedSession from './utils/feedSessionContinuity';
import booksListCache from './utils/booksListCache';
import * as richText from './utils/richText';
import * as rating from './utils/rating';
import { consumeOneTimeNotification } from './utils/oneTimeNotification';
import { formatCount, selectForm } from './utils/ukrainianPluralization';
import {
    consumeSessionExpiryNotification,
    installSessionExpiryInterceptor,
} from './utils/sessionExpiry';
import {
    initializeReviewSpoilerProtection,
} from './utils/reviewSpoiler';

// Экспортируем Vue глобально для использования в Blade шаблонах
window.Vue = Vue;

// Экспортируем кеши глобально для использования в Blade шаблонах
window.bookStatusCache = bookStatusCache;
window.bookIdCache = bookIdCache;
window.booksListCache = booksListCache;
window.FoxyRichText = richText;
window.FoxyRating = rating;
window.FoxyUkrainianCount = Object.freeze({ formatCount, selectForm });

const initializeProtectedReviewContent = () => initializeReviewSpoilerProtection(document);
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProtectedReviewContent);
} else {
    initializeProtectedReviewContent();
}

// Регистрируем компоненты глобально
Vue.component('book-card', BookCard);
Vue.component('add-to-library-modal', AddToLibraryModal);
Vue.component('add-to-library-button', AddToLibraryButton);
Vue.component('favorite-toggle', FavoriteToggle);
Vue.component('quick-shelf-picker', QuickShelfPicker);
Vue.component('library-collection', LibraryCollection);
Vue.component('user-library-book-card', UserLibraryBookCard);
Vue.component('notification-bell', NotificationBell);
Vue.component('notifications-page', NotificationsPage);
Vue.component('notification-filters', NotificationFilters);
Vue.component('notification-card', NotificationCard);
Vue.component('notification-pagination', NotificationPagination);
Vue.component('discussion-reply', DiscussionReply);
Vue.component('discussion-replies-list', DiscussionRepliesList);
Vue.component('review-reply', ReviewReply);
Vue.component('reviews-replies-list', ReviewsRepliesList);
Vue.component('review-detail-book-context', ReviewDetailBookContext);
Vue.component('quote-card', QuoteCard);
Vue.component('quotes-list', QuotesList);
Vue.component('quotes-page-list', QuotesPageList);
Vue.component('add-quote-modal', AddQuoteModal);
Vue.component('interesting-facts', InterestingFacts);
Vue.component('book-reviews-list', BookReviewsList);
Vue.component('reviews-list', BookReviewsList);
Vue.component('fact-card', FactCard);
Vue.component('facts-list', FactsList);
Vue.component('facts-page-list', FactsPageList);
Vue.component('price-comparison', PriceComparison);
Vue.component('hashtag-contribution-list', HashtagContributionList);
Vue.component('unified-content-list', UnifiedContentList);
Vue.component('content-filters', ContentFilters);
Vue.component('report-modal', ReportModal);
Vue.component('report-button', ReportButton);
Vue.component('featured-quotes-carousel', FeaturedQuotesCarousel);
Vue.component('libraries-explorer', LibrariesExplorer);
Vue.component('library-books-manager', LibraryBooksManager);
Vue.component('book-search', BookSearch);
Vue.component('discussion-work-selector', DiscussionWorkSelector);
Vue.component('pagination', Pagination);
Vue.component('toast-notification', ToastNotification);
Vue.component('decision-modal', DecisionModal);
Vue.component('opinion-type-icon', OpinionTypeIcon);
Vue.component('double-range-slider', DoubleRangeSlider);
Vue.component('rating-input', RatingInput);
Vue.component('user-avatar', UserAvatar);
Vue.component('reading-context-selector', ReadingContextSelector);

// Импортируем Axios
import axios from 'axios';

// Настройка Axios
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';

// Получаем CSRF токен
const token = document.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.getAttribute('content');
}

// Экспортируем axios глобально для использования в Blade шаблонах
window.axios = axios;

const pageStartedAuthenticated = Boolean(window.isAuthenticated);
installSessionExpiryInterceptor(axios, {
    runtime: window,
    document,
    startedAuthenticated: pageStartedAuthenticated,
});

// Экспортируем shareContent глобально для использования в Blade шаблонах
import { shareContent } from './utils/shareHelper';
window.shareContent = shareContent;

// Глобальные переменные
window.repliesPages = {};

// Функции для управления ветками (сворачивание/разворачивание)
window.toggleBranch = function(branchId) {
    const branchContent = document.getElementById(`branchContent${branchId}`);
    const toggleButton = document.getElementById(`branchToggle${branchId}`);
    
    if (branchContent && toggleButton) {
        const isCollapsed = branchContent.classList.contains('collapsed');
        
        if (isCollapsed) {
            // Разворачиваем ветку
            branchContent.classList.remove('collapsed');
            branchContent.classList.add('expanded');
            toggleButton.classList.remove('collapsed');
            toggleButton.innerHTML = `
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
                Свернуть
            `;
        } else {
            // Сворачиваем ветку
            branchContent.classList.remove('expanded');
            branchContent.classList.add('collapsed');
            toggleButton.classList.add('collapsed');
            toggleButton.innerHTML = `
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                </svg>
                Развернуть
            `;
        }
    }
};

// Функция для создания уникального ID ветки
window.generateBranchId = function(parentId, depth) {
    return `branch_${parentId}_${depth}`;
};

// Функции для работы с рецензиями
window.toggleReplyForm = function(reviewId) {
    const form = document.getElementById(`replyForm${reviewId}`);
    if (form) {
        form.classList.toggle('hidden');
        if (!form.classList.contains('hidden')) {
            form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }
};

window.loadReplies = function(reviewId, page = 1) {
    console.log('Loading replies for review:', reviewId, 'page:', page);
    
    axios.get(`/api/reviews/${reviewId}/replies?page=${page}`)
        .then(response => {
            const data = response.data;
            console.log('Replies loaded:', data);
            
            const container = document.getElementById(`repliesContainer${reviewId}`);
            if (container) {
                container.classList.remove('hidden');
                
                if (page === 1) {
                    container.innerHTML = ''; // Очищаем при первой загрузке
                }
                
                // Добавляем ответы
                data.data.forEach(reply => {
                    container.appendChild(createReplyElement(reply));
                });
                
                // Управляем кнопкой "Загрузить еще"
                const loadMoreContainer = document.getElementById(`loadMoreContainer${reviewId}`);
                if (loadMoreContainer) {
                    if (data.next_page_url) {
                        loadMoreContainer.classList.remove('hidden');
                        window.repliesPages[reviewId] = page + 1;
                    } else {
                        loadMoreContainer.classList.add('hidden');
                    }
                }
                
                // Скрываем кнопку "Показать ответы" и показываем "Скрыть ответы"
                const showButton = document.querySelector(`button[onclick="loadReplies(${reviewId}, 1)"]`);
                if (showButton && page === 1) {
                    showButton.style.display = 'none';
                    
                    // Проверяем, есть ли уже кнопка "Скрыть ответы"
                    let hideButton = showButton.parentNode.querySelector('.hide-replies-btn');
                    if (!hideButton) {
                        // Добавляем кнопку "Скрыть ответы"
                        hideButton = document.createElement('button');
                        hideButton.className = 'hide-replies-btn text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 font-medium transition-colors';
                        hideButton.onclick = () => hideReplies(reviewId);
                        hideButton.innerHTML = `
                            Скрыть ответы
                            <svg class="w-4 h-4 inline ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
                            </svg>
                        `;
                        showButton.parentNode.appendChild(hideButton);
                    }
                }
            }
        })
        .catch(error => {
            console.error('Error loading replies:', error);
            showNotification('Ошибка при загрузке ответов', 'error');
        });
};

window.loadMoreReplies = function(reviewId) {
    const page = window.repliesPages[reviewId] || 2;
    loadReplies(reviewId, page);
};

// Функция для переключения показа/скрытия ответов
window.toggleReplies = function(reviewId) {
    const container = document.getElementById(`repliesContainer${reviewId}`);
    const toggleButton = document.querySelector(`[data-review-id="${reviewId}"].reply-toggle-btn`);
    
    if (!container || !toggleButton) return;
    
    const isHidden = container.classList.contains('hidden');
    
    if (isHidden) {
        // Показываем ответы
        container.classList.remove('hidden');
        toggleButton.setAttribute('data-action', 'hide');
        toggleButton.innerHTML = `
            Скрыть ответы
            <svg class="w-4 h-4 inline ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
            </svg>
        `;
    } else {
        // Скрываем ответы
        container.classList.add('hidden');
        toggleButton.setAttribute('data-action', 'show');
        toggleButton.innerHTML = `
            Показать ответы
            <svg class="w-4 h-4 inline ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
        `;
    }
};

// Функция для скрытия ответов
window.hideReplies = function(reviewId) {
    const container = document.getElementById(`repliesContainer${reviewId}`);
    const toggleButton = document.querySelector(`[data-review-id="${reviewId}"].reply-toggle-btn`);
    
    if (!container || !toggleButton) return;
    
    container.classList.add('hidden');
    toggleButton.setAttribute('data-action', 'show');
    toggleButton.innerHTML = `
        Показать ответы
        <svg class="w-4 h-4 inline ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
        </svg>
    `;
};

window.createReplyElement = function(reply, depth = 0) {
    const div = document.createElement('div');
    const currentDepth = depth + 1;
    const isThirdLevel = currentDepth >= 3;
    
    // Простые отступы для первых двух уровней
    const marginLeft = currentDepth <= 2 ? currentDepth * 0.5 : 1; // Максимум 1rem для третьего уровня
    
    div.className = `reply-item ml-${marginLeft} border-l-2 border-gray-200 dark:border-gray-700 pl-2 bg-gray-50 dark:bg-gray-800/30 rounded-lg p-4 border border-gray-200 dark:border-gray-700`;
    div.setAttribute('data-reply-id', reply.id);
    div.setAttribute('data-depth', currentDepth);
    
    const authorName = reply.user ? reply.user.name : 'Гость';
    const isGuest = !reply.user;
    
    const avatarHtml = isGuest ? 
        `<div class="w-8 h-8 bg-gradient-to-br from-gray-400 to-gray-600 rounded-full flex items-center justify-center relative">
            <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
            </svg>
            <div class="absolute -bottom-1 -right-1 w-3 h-3 bg-orange-500 rounded-full flex items-center justify-center">
                <span class="text-xs text-white font-bold">Г</span>
            </div>
        </div>` :
        `<div class="w-8 h-8 bg-gradient-to-br from-primary-500 to-secondary-600 rounded-full flex items-center justify-center">
            <span class="text-xs font-bold text-white">${authorName.charAt(0)}</span>
        </div>`;
    
    const guestBadge = isGuest ? 
        `<span class="ml-2 px-2 py-1 text-xs bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-200 rounded-full">Гость</span>` : '';
    
    // Форматируем время
    let timeText = 'щойно';
    if (reply.created_at) {
        const createdDate = new Date(reply.created_at);
        const now = new Date();
        const diffMs = now - createdDate;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);
        
        if (diffMins < 1) {
            timeText = 'щойно';
        } else if (diffMins < 60) {
            timeText = `${diffMins} хв тому`;
        } else if (diffHours < 24) {
            timeText = `${diffHours} год тому`;
        } else {
            timeText = `${diffDays} дн тому`;
        }
    }
    
    div.innerHTML = `
        <div class="flex items-start space-x-3">
            ${avatarHtml}
            <div class="flex-1 min-w-0">
                <div class="flex items-center space-x-2 mb-2">
                    <span class="font-medium text-gray-900 dark:text-white">${authorName}</span>
                    ${guestBadge}
                    <span class="text-xs text-gray-500 dark:text-gray-400">${timeText}</span>
                </div>
                <p class="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">${reply.content}</p>
                <div class="mt-3 flex items-center space-x-4">
                    <!-- Like/Dislike Section для ответов -->
                    <div class="flex items-center space-x-2">
                        <!-- Like Button -->
                        <button onclick="likeReview(${reply.id})"
                                class="like-btn p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-gray-400 hover:text-red-500">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
                            </svg>
                        </button>
                        <span class="likes-count text-xs text-gray-600 dark:text-gray-400">${reply.likes_count || 0}</span>
                        
                        <!-- Dislike Button -->
                        <button onclick="dislikeReview(${reply.id})"
                                class="dislike-btn p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-gray-400 hover:text-blue-500">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.912c.163 0 .322.028.475.082l3.276 1.5c.337.154.563.504.563.877v6.541c0 .373-.226.723-.563.877l-3.276 1.5a2 2 0 01-.475.082H10V14z"/>
                            </svg>
                        </button>
                        <span class="dislikes-count text-xs text-gray-600 dark:text-gray-400">${reply.dislikes_count || 0}</span>
                    </div>
                    
                    <button onclick="toggleReplyForm(${reply.id})" class="text-xs text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">
                        Ответить
                    </button>
                </div>
            </div>
            
            <!-- Reply Form для ответов -->
            <div id="replyForm${reply.id}" class="hidden mt-3 p-3 bg-gray-50 dark:bg-gray-800/30 rounded-lg border border-gray-200 dark:border-gray-700">
                <h5 class="text-xs font-medium text-gray-900 dark:text-white mb-2">Ваш ответ</h5>
                <form onsubmit="submitReply(event, ${reply.id}, null)" class="space-y-2">
                    <textarea 
                        name="content" 
                        rows="2" 
                        class="w-full px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded focus:ring-1 focus:ring-primary-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                        placeholder="Напишите ваш ответ..."
                        required
                    ></textarea>
                    <div class="flex items-center justify-end space-x-2">
                        <button type="button" onclick="toggleReplyForm(${reply.id})" class="px-2 py-1 text-xs text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors">
                            Отмена
                        </button>
                        <button type="submit" class="px-3 py-1 bg-primary-600 hover:bg-primary-700 text-white text-xs font-medium rounded transition-colors">
                            Ответить
                        </button>
                    </div>
                </form>
            </div>
        </div>
    `;
    
    return div;
};

window.submitReply = function(event, reviewId, bookId) {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    
    // Определяем, авторизован ли пользователь
    const userMeta = document.querySelector('meta[name="user-id"]');
    const userId = userMeta ? userMeta.getAttribute('content') : null;
    const isGuest = !userId || userId === '';
    
    // Получаем slug книги из URL страницы
    const pathParts = window.location.pathname.split('/');
    const bookSlug = pathParts[2]; // /books/{slug}/...
    
    // Определяем, является ли это ответом на ответ или на основную рецензию
    const reviewElement = document.querySelector(`[data-review-id="${reviewId}"]`);
    let targetReviewId = reviewId;
    
    // Если это ответ на ответ, находим родительскую рецензию
    if (!reviewElement) {
        // Ищем родительский элемент с data-review-id
        const replyElement = document.querySelector(`[data-reply-id="${reviewId}"]`);
        if (replyElement) {
            const parentReview = replyElement.closest('[data-review-id]');
            if (parentReview) {
                targetReviewId = parentReview.getAttribute('data-review-id');
            }
        }
    }
    
    // URL для ответа
    const url = `/books/${bookSlug}/reviews/${targetReviewId}/replies`;
    
    // Debug information
    console.log('Reply submission debug:', {
        reviewId,
        targetReviewId,
        bookId,
        isGuest,
        url,
        formData: Object.fromEntries(formData)
    });
    
    // Отправляем запрос через Axios
    axios.post(url, formData)
        .then(response => {
            const data = response.data;
            if (data.success) {
                showNotification(data.message || 'Ответ добавлен успешно!', 'success');
                
                // Обновляем счетчик ответов
                const toggleButton = document.querySelector(`[data-review-id="${targetReviewId}"].reply-toggle-btn`);
                if (toggleButton) {
                    const currentText = toggleButton.textContent;
                    const currentCount = parseInt(currentText.match(/\d+/)[0]) || 0;
                    const newCount = currentCount + 1;
                    
                    // Обновляем текст кнопки
                    toggleButton.innerHTML = `
                        Показать ${newCount} ${newCount === 1 ? 'ответ' : (newCount === 2 || newCount === 3 || newCount === 4 ? 'ответа' : 'ответов')}
                        <svg class="w-4 h-4 inline ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                    `;
                }
                
                // Скрываем форму ответа
                toggleReplyForm(reviewId);
                
                // Если ответы уже загружены, добавляем новый ответ
                const container = document.getElementById(`repliesContainer${targetReviewId}`);
                if (container && !container.classList.contains('hidden')) {
                    // Если это ответ на ответ, находим родительский элемент
                    if (reviewId !== targetReviewId) {
                        const parentReply = document.querySelector(`[data-reply-id="${reviewId}"]`);
                        if (parentReply) {
                            // Ищем контейнер для ответов на этот ответ
                            let repliesContainer = parentReply.querySelector('.replies-container');
                            if (!repliesContainer) {
                                // Создаем контейнер если его нет
                                repliesContainer = document.createElement('div');
                                repliesContainer.className = 'replies-container space-y-3';
                                parentReply.appendChild(repliesContainer);
                            }
                            // Определяем глубину для нового ответа
                            const parentDepth = parseInt(parentReply.getAttribute('data-depth') || 0);
                            const newReply = createReplyElement(data.reply, parentDepth);
                            repliesContainer.appendChild(newReply);
                            
                            // Настраиваем обработчики для новых кнопок
                            const newToggleButton = newReply.querySelector('.reply-toggle-btn');
                            if (newToggleButton) {
                                setupReplyToggleButton(newToggleButton);
                            }
                        }
                    } else {
                        // Если это ответ на основную рецензию
                        const newReply = createReplyElement(data.reply, 0);
                        container.appendChild(newReply);
                        
                        // Настраиваем обработчики для новых кнопок
                        const newToggleButton = newReply.querySelector('.reply-toggle-btn');
                        if (newToggleButton) {
                            setupReplyToggleButton(newToggleButton);
                        }
                    }
                }
            } else {
                showNotification('Ошибка при добавлении ответа', 'error');
            }
        })
        .catch(error => {
            console.error('Error submitting reply:', error);
            let errorMessage = 'Ошибка при добавлении ответа';
            
            if (error.response) {
                if (error.response.status === 422) {
                    errorMessage = 'Ошибка валидации: ' + Object.values(error.response.data.errors).flat().join(', ');
                } else if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            }
            
            showNotification(errorMessage, 'error');
        });
};

window.likeReview = function(reviewId) {
    // AJAX запрос для лайка
    axios.post(`/api/reviews/${reviewId}/like`)
        .then(response => {
            const data = response.data;
            if (data.success) {
                // Обновляем счетчики для рецензий
                let likesCount = document.querySelector(`[data-review-id="${reviewId}"] .likes-count`);
                let dislikesCount = document.querySelector(`[data-review-id="${reviewId}"] .dislikes-count`);
                let likeBtn = document.querySelector(`[data-review-id="${reviewId}"] .like-btn`);
                let dislikeBtn = document.querySelector(`[data-review-id="${reviewId}"] .dislike-btn`);
                
                // Если не нашли для рецензии, ищем для ответа
                if (!likesCount) {
                    likesCount = document.querySelector(`[data-reply-id="${reviewId}"] .likes-count`);
                    dislikesCount = document.querySelector(`[data-reply-id="${reviewId}"] .dislikes-count`);
                    likeBtn = document.querySelector(`[data-reply-id="${reviewId}"] .like-btn`);
                    dislikeBtn = document.querySelector(`[data-reply-id="${reviewId}"] .dislike-btn`);
                }
                
                if (likesCount) likesCount.textContent = data.likesCount;
                if (dislikesCount) dislikesCount.textContent = data.dislikesCount;
                
                // Обновляем состояние кнопок
                if (likeBtn) {
                    if (data.isLiked) {
                        likeBtn.classList.add('text-red-500');
                        likeBtn.querySelector('svg').setAttribute('fill', 'currentColor');
                    } else {
                        likeBtn.classList.remove('text-red-500');
                        likeBtn.querySelector('svg').setAttribute('fill', 'none');
                    }
                }
                
                // Сбрасываем дизлайк если был
                if (dislikeBtn && data.isLiked) {
                    dislikeBtn.classList.remove('text-blue-500');
                    dislikeBtn.querySelector('svg').setAttribute('fill', 'none');
                }
                
                showNotification(data.message, 'success');
            }
        })
        .catch(error => {
            console.error('Error liking review:', error);
            showNotification('Ошибка при лайке', 'error');
        });
};

window.dislikeReview = function(reviewId) {
    // AJAX запрос для дизлайка
    axios.post(`/api/reviews/${reviewId}/dislike`)
        .then(response => {
            const data = response.data;
            if (data.success) {
                // Обновляем счетчики для рецензий
                let likesCount = document.querySelector(`[data-review-id="${reviewId}"] .likes-count`);
                let dislikesCount = document.querySelector(`[data-review-id="${reviewId}"] .dislikes-count`);
                let likeBtn = document.querySelector(`[data-review-id="${reviewId}"] .like-btn`);
                let dislikeBtn = document.querySelector(`[data-review-id="${reviewId}"] .dislike-btn`);
                
                // Если не нашли для рецензии, ищем для ответа
                if (!likesCount) {
                    likesCount = document.querySelector(`[data-reply-id="${reviewId}"] .likes-count`);
                    dislikesCount = document.querySelector(`[data-reply-id="${reviewId}"] .dislikes-count`);
                    likeBtn = document.querySelector(`[data-reply-id="${reviewId}"] .like-btn`);
                    dislikeBtn = document.querySelector(`[data-reply-id="${reviewId}"] .dislike-btn`);
                }
                
                if (likesCount) likesCount.textContent = data.likesCount;
                if (dislikesCount) dislikesCount.textContent = data.dislikesCount;
                
                // Обновляем состояние кнопок
                if (dislikeBtn) {
                    if (data.isDisliked) {
                        dislikeBtn.classList.add('text-blue-500');
                        dislikeBtn.querySelector('svg').setAttribute('fill', 'currentColor');
                    } else {
                        dislikeBtn.classList.remove('text-blue-500');
                        dislikeBtn.querySelector('svg').setAttribute('fill', 'none');
                    }
                }
                
                // Сбрасываем лайк если был
                if (likeBtn && data.isDisliked) {
                    likeBtn.classList.remove('text-red-500');
                    likeBtn.querySelector('svg').setAttribute('fill', 'none');
                }
                
                showNotification(data.message, 'success');
            }
        })
        .catch(error => {
            console.error('Error disliking review:', error);
            showNotification('Ошибка при дизлайке', 'error');
        });
};

window.editReview = function(reviewId) {
    // Реализация редактирования рецензии
    console.log('Edit review:', reviewId);
};

window.deleteReview = async function(reviewId) {
    const confirmed = await confirm('Ви впевнені, що хочете видалити цю рецензію?', 'Підтвердження', 'warning');
    if (confirmed) {
        axios.delete(`/api/reviews/${reviewId}`)
            .then(response => {
                const data = response.data;
                if (data.success) {
                    const reviewElement = document.querySelector(`[data-review-id="${reviewId}"]`);
                    if (reviewElement) {
                        reviewElement.remove();
                    }
                    showNotification(data.message, 'success');
                }
            })
            .catch(error => {
                console.error('Error deleting review:', error);
                showNotification('Ошибка при удалении рецензии', 'error');
            });
    }
};

window.showNotification = function(message, type = 'info') {
    // Простая система уведомлений
    const notification = document.createElement('div');
    notification.className = `fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 ${
        type === 'success' ? 'bg-green-500 text-white' : 
        type === 'error' ? 'bg-red-500 text-white' : 
        'bg-blue-500 text-white'
    }`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
        notification.remove();
    }, 3000);
};

// Compatibility handle for non-modal transient notifications.
window.alertModalInstance = null;

// Initialize the non-modal toast host after Vue is loaded.
function initAlertModal() {
    if (window.alertModalInstance) {
        return window.alertModalInstance;
    }
    
    const container = document.getElementById('global-alert-modal-container');
    if (!container || !window.Vue) {
        return null;
    }
    
    window.alertModalInstance = new Vue({
        el: container,
        components: {
            'toast-notification': ToastNotification
        },
        template: '<toast-notification ref="modal"></toast-notification>'
    });
    
    return window.alertModalInstance;
}

function presentInitialNotifications(alertInstance) {
    if (!alertInstance || !alertInstance.$refs.modal) {
        return;
    }

    const presentSessionExpiry = (message) => alertInstance.$refs.modal.alert(message, 'Увага', 'warning');
    const presentVerificationSuccess = (message) => alertInstance.$refs.modal.alert(message, 'Успіх', 'success');
    const sessionExpiryPresented = !pageStartedAuthenticated
        && consumeSessionExpiryNotification(window, presentSessionExpiry);

    if (!sessionExpiryPresented) {
        consumeOneTimeNotification(
            window.__FOXY_INITIAL_NOTIFICATIONS__,
            'verificationSuccess',
            presentVerificationSuccess
        );
    }
}

// Interactive decisions intentionally use a separate, timer-free component.
window.decisionModalInstance = null;

function initDecisionModal() {
    if (window.decisionModalInstance) {
        return window.decisionModalInstance;
    }

    const container = document.getElementById('global-decision-modal-container');
    if (!container || !window.Vue) {
        return null;
    }

    window.decisionModalInstance = new Vue({
        el: container,
        components: {
            'decision-modal': DecisionModal
        },
        template: '<decision-modal ref="modal"></decision-modal>'
    });

    return window.decisionModalInstance;
}

function initializeGlobalUi() {
    const alertInstance = initAlertModal();
    presentInitialNotifications(alertInstance);
    initDecisionModal();
    initCategoryChildNav();
    feedSession.initializeContextualBack();
    initPageSwipers();
}

// Home's Vue mounts can occur after the bundle's initial ready callback.
document.addEventListener('foxy:homepage-mounted', () => initPageSwipers());
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGlobalUi, { once: true });
} else {
    initializeGlobalUi();
}

// Replace window.alert
const originalAlert = window.alert;
window.alert = function(message, title, type) {
    const instance = initDecisionModal();
    if (instance && instance.$refs.modal) {
        return instance.$refs.modal.inform(message, title || 'Повідомлення', type || 'info');
    }
    // Fallback to original alert if Vue not loaded
    if (originalAlert && typeof originalAlert === 'function') {
        originalAlert(message);
        return Promise.resolve(true);
    }
    console.warn('Alert:', message);
    return Promise.resolve(true);
};

// Replace window.confirm
const originalConfirm = window.confirm;
window.confirm = function(message, title, type) {
    const instance = initDecisionModal();
    if (instance && instance.$refs.modal) {
        return instance.$refs.modal.confirm(message, title || 'Підтвердження', type || 'warning').catch(() => false);
    }
    // Fallback to original confirm if Vue not loaded
    if (originalConfirm && typeof originalConfirm === 'function') {
        return Promise.resolve(originalConfirm(message));
    }
    console.warn('Confirm:', message);
    return Promise.resolve(false);
};

// Replace window.prompt
const originalPrompt = window.prompt;
window.prompt = function(message, defaultValue, title, placeholder) {
    const instance = initDecisionModal();
    if (instance && instance.$refs.modal) {
        return instance.$refs.modal.prompt(message, defaultValue || '', title || 'Введення', placeholder || '').catch(() => null);
    }
    // Fallback to original prompt if Vue not loaded
    if (originalPrompt && typeof originalPrompt === 'function') {
        return Promise.resolve(originalPrompt(message, defaultValue || ''));
    }
    console.warn('Prompt:', message);
    return Promise.resolve(null);
};

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
    console.log('App loaded successfully!');
    
    // Настройка звездочек для рейтинга
    setupRatingStars();
    
    // Настройка обработчиков для кнопок показать/скрыть ответы
    setupReplyToggleButtons();
    
});

// Функция настройки обработчиков для кнопок показать/скрыть ответы
function setupReplyToggleButtons() {
    // Находим все кнопки показать/скрыть ответы
    const toggleButtons = document.querySelectorAll('.reply-toggle-btn');
    
    toggleButtons.forEach(button => {
        setupReplyToggleButton(button);
    });
}

// Функция для настройки одной кнопки показать/скрыть ответы
function setupReplyToggleButton(button) {
    // Убираем старые обработчики
    button.removeEventListener('click', button._replyToggleHandler);
    
    // Создаем новый обработчик
    button._replyToggleHandler = function(e) {
        e.preventDefault();
        const reviewId = this.getAttribute('data-review-id');
        const action = this.getAttribute('data-action');
        
        if (action === 'show') {
            toggleReplies(reviewId);
        } else if (action === 'hide') {
            hideReplies(reviewId);
        }
    };
    
    // Добавляем обработчик
    button.addEventListener('click', button._replyToggleHandler);
}

// Функция настройки звездочек рейтинга
function setupRatingStars() {
    const ratingContainers = document.querySelectorAll('[id^="ratingStars"]');
    
    ratingContainers.forEach(container => {
        const stars = container.querySelectorAll('.star-btn');
        const input = container.parentElement.querySelector('input[type="hidden"]');
        
        if (stars && input) {
            stars.forEach((star, index) => {
                star.addEventListener('click', () => {
                    const rating = index + 1;
                    input.value = rating;
                    
                    // Обновляем отображение звездочек
                    stars.forEach((s, i) => {
                        if (i < rating) {
                            s.classList.add('text-accent-500');
                            s.classList.remove('text-gray-300', 'dark:text-gray-600');
                        } else {
                            s.classList.remove('text-accent-500');
                            s.classList.add('text-gray-300', 'dark:text-gray-600');
                        }
                    });
                });
                
                star.addEventListener('mouseenter', () => {
                    const rating = index + 1;
                    stars.forEach((s, i) => {
                        if (i < rating) {
                            s.classList.add('text-accent-500');
                            s.classList.remove('text-gray-300', 'dark:text-gray-600');
                        }
                    });
                });
                
                star.addEventListener('mouseleave', () => {
                    const currentRating = parseInt(input.value) || 0;
                    stars.forEach((s, i) => {
                        if (i < currentRating) {
                            s.classList.add('text-accent-500');
                            s.classList.remove('text-gray-300', 'dark:text-gray-600');
                        } else {
                            s.classList.remove('text-accent-500');
                            s.classList.add('text-gray-300', 'dark:text-gray-600');
                        }
                    });
                });
            });
        }
    });
}
